import Cookies from 'universal-cookie';


export const checkSignedIn = async () => {

    const cookies = new Cookies();
    let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_AUTH_AUTHENTICATE}`, {
        headers: {
            'X-ACCESS-TOKEN': cookies.get('token')
        }
    });

    return response.ok;
}